import React from 'react';
import { CollapseTableRowButton } from '../Buttons/TableButtons';
import ShowLoadingSpinner from '../ShowLoadingSpinner';

export const SubSectionTitle = props => {
    const { title, number, className, collapseName, toggleCollapsed, collapsed, buttons, isLoading } = props;

    return (
        <div className={`d-grid grid-cols-2 mt-2 form-subsection-title ${className ? className : ''}`}>
            <div>
                {collapseName ? (
                    <CollapseTableRowButton
                        collapsed={collapsed}
                        onClick={() => toggleCollapsed(collapseName, !collapsed)}
                    />
                ) : (
                    ''
                )}
                {number && <span className="mr-2 logo-font form-subsection-number">{number}</span>}
                <h5 className={`d-inline logo-font gradient mb-2 ${className} ${collapseName ? 'ml-2' : ''}`}>
                    {title}
                </h5>
            </div>
            <div className="grid-js-end grid-js-bottom mb-2">
                {isLoading ? <ShowLoadingSpinner isLoading size={20} /> : buttons}
            </div>
        </div>
    );
};
